import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visibleNavbarItem: true,
  visibleNavbarInfo: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setVisibleNavbarItem(state, action) {
      state.visibleNavbarItem = action.payload;
    },
    setVisibleNavbarInfo(state, action) {
      state.visibleNavbarInfo = action.payload;
    },
  },
});

export const { setVisibleNavbarItem, setVisibleNavbarInfo } = uiSlice.actions;
export default uiSlice.reducer;
